















































































import _ from "lodash";
import { Component, Vue } from "vue-property-decorator";
import DashboardProjectItem from "./DashboardProjectItem.vue";
import AppHeader from "./AppHeader.vue";
import { Project, getAssignedProjects } from "@/api/project-api";
import { ProjectMessage, getUnreadReplyMessages } from "@/api/message-api";
import { getProjectStatusCode } from "@/models/project-status";
import VChatMessage from "./VChatMessage.vue";
import ProjectMessageList from "@/components/ProjectMessageList.vue";
import VSearchBar from "../components/VSearchBar.vue";
import UserTaskList from "../task/ui/pages/UserTaskList.vue";
import SearchDashboardProjectBar from "../components/SearchDashboardProjectBar.vue";

@Component({
  components: {
    SearchDashboardProjectBar,
    DashboardProjectItem,
    AppHeader,
    UserTaskList,
    VSearchBar,
    VChatMessage,
    ProjectMessageList
  }
})
export default class DashboardPage extends Vue {
  assignedProjects: Project[] = [];
  projectMessages: ProjectMessage[] = [];
  resetLoadInfinite = 0;
  keyword = "";
  status = String(getProjectStatusCode("施工中"));

  async loadMessages(projects: Project[]) {
    // 一旦ダミーのリストを設定する
    this.projectMessages = this.assignedProjects.map(p => ({
      projectId: p.projectId,
      projectName: p.name,
      messageList: []
    }));
    this.projectMessages = await getUnreadReplyMessages(
      projects.map(p => p.projectId)
    );
  }

  canReadMaster() {
    return this.$store.getters.permissions.includes("service/master_read");
  }

  async search(projects: Project[], status: any, keyword: any) {
    this.status = status;
    this.keyword = keyword;
    this.resetLoadInfinite += 1;

    this.assignedProjects = _.orderBy(projects, "created", "desc");
    await this.loadMessages(this.assignedProjects);
  }

  async loadInfinite($state: any) {
    const loadedProjectItems: Project[] = await getAssignedProjects(
      this.keyword,
      this.status,
      this.assignedProjects.length
    );

    if (loadedProjectItems.length) {
      if (loadedProjectItems.length == 0) {
        this.assignedProjects = loadedProjectItems;
        await this.loadMessages(this.assignedProjects);
      } else {
        this.assignedProjects = this.assignedProjects.concat(
          loadedProjectItems
        );
        await this.loadMessages(this.assignedProjects);
      }
      $state.loaded();
    } else {
      $state.complete();
    }
  }
}
